<template>
  <div>
    <a-card :bordered="false" :bodyStyle="tstyle">
      <div class="table-page-search-wrapper" v-if="hasPerm('recipe:page')">
        <a-form layout="inline">
          <a-row :gutter="48">


              <a-col :md="8" :sm="24">
                <a-form-item label="创建日期">
                  <a-date-picker style="width: 100%" placeholder="请选择" @change="onChangectstamp" />
                </a-form-item>
              </a-col>

              <a-col :md="8" :sm="24">
                <a-form-item label="批次号">
                  <a-input v-model="queryParam.batchNum" allow-clear placeholder="精准查询" />
                </a-form-item>
              </a-col>

              <a-col :md="8" :sm="24">
                <a-form-item label="姓名">
                  <a-input v-model="queryParam.userName" allow-clear placeholder="模糊查询" />
                </a-form-item>
              </a-col>
            
            <a-col :md="8" :sm="24" >
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="$refs.table.refresh(true)" >查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>
    <a-card :bordered="false">
      <s-table
        ref="table"
        :columns="columns"
        :data="loadData"
        :alert="options.alert"
        :rowKey="(record) => record.id"
        :rowSelection="options.rowSelection"
      >
      <span  slot="userType" slot-scope="text, record"> 
          {{record.userType == '1'? '患者' : record.userType == '2' ? '医生' : '' }}
      </span>
      <span  slot="status" slot-scope="text, record"> 
          {{record.status == '0'? '发送成功' : record.status == '1' ?  '发送失败' : ""  }}
      </span>
      <span  slot="receiveType" slot-scope="text, record"> 
          {{record.receiveType == '0'? '物流配送' : record.receiveType == '1'? '到院领取' : '' }}
      </span>

      
      </s-table>
      
    </a-card>
    <add-form-xi ref="addFormXi" @ok="handleOk" />
    <add-form-zhong ref="addFormZhong" @ok="handleOk" />
  </div>
</template>
<script>
  import { STable, XDown } from '@/components'
  import moment from 'moment'
  import { baUserPointsRewardPage,} from '@/api/modular/interhospital/award/awardManage'
  import addFormXi from './addForm.vue'
  import addFormZhong from './addFormZhong.vue'
  import editForm from './editForm.vue'
  export default {
    components: {
      STable,
      editForm,
      addFormXi,
      addFormZhong,
      XDown
    },
    data () {
      return {
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {},
       
        // 表头
        columns: [
          {
            title: '序号',
            align: 'center',
            dataIndex: 'id'
          },
          {
            title: '创建日期',
            align: 'center',
            dataIndex: 'createTime'
          },
          {
            title: '批次号',
            align: 'center',
            dataIndex: 'batchNum',
          },
          {
            title: 'ID',
            align: 'center',
            dataIndex: 'userId',
          },
          {
            title: '姓名',
            align: 'center',
            dataIndex: 'userName'
          },
          {
            title: '人员类别',
            align: 'center',
            dataIndex: 'userType',
            scopedSlots: { customRender: 'userType' },
          },
          {
            title: '发送状态',
            align: 'center',
            dataIndex: 'status',
            scopedSlots: { customRender: 'status' },
          },
          {
            title: '奖品名称',
            align: 'center',
            dataIndex: 'reward',
          },
          {
            title: '领取方式',
            align: 'center',
            dataIndex: 'receiveType',
            scopedSlots: { customRender: 'receiveType' },
          },
          {
            title: '领取时间',
            align: 'center',
            dataIndex: 'receiveDate'
          },
        ],
        tstyle: { 'padding-bottom': '0px', 'margin-bottom': '10px' },
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return baUserPointsRewardPage(Object.assign(parameter, this.switchingDate())).then((res) => {
            res.data.rows.map((item,index)=>{
              item['id'] = index+1
            })
            return res.data
          })
        },
        selectedRowKeys: [],
        selectedRows: [],
        options: {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
      }
    },
    methods: {
      moment,
      /**
       * 查询参数组装
       */
      switchingDate () {
        const queryParamctstamp = this.queryParam.ctstampDate
        if (queryParamctstamp != null) {
            this.queryParam.ctstamp = moment(queryParamctstamp).format('YYYY-MM-DD')
            if (queryParamctstamp.length < 1) {
                delete this.queryParam.ctstamp
            }
        }
        const obj = JSON.parse(JSON.stringify(this.queryParam))
        return obj
      },
      
      // 时间框赋值
      onChangectstamp(date, dateString) {
        this.queryParam.startTime = dateString
      },
     

      handleOk () {
        this.$refs.table.refresh()
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      
    }
  }
</script>
<style lang="less">
  .table-operator {
    margin-bottom: 18px;
  }
  button {
    margin-right: 8px;
  }
</style>
